import React, { useState, useEffect } from "react";
import api from "../Service/api";
import "./ExpenseCategories.css"; // optional for professional styling

function ExpenseCategories() {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryType, setCategoryType] = useState("DAILY");
  const [filterType, setFilterType] = useState("DAILY");
  const [editCategory, setEditCategory] = useState(null);

  // Fetch categories on load or when filter changes
  useEffect(() => {
    fetchCategories();
  }, [filterType]);

  const fetchCategories = async () => {
    try {
      const res = await api.get("/Expenses/get/category", {
        params: { type: filterType },
      });
      setCategories(res.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch categories");
    }
  };

const handleAddOrUpdate = async () => {
  if (!categoryName.trim()) {
    alert("Please enter category name");
    return;
  }

  const dto = {
    name: categoryName.trim(),
    type: categoryType
  };

  try {
    if (editCategory && editCategory.id) {
      console.log("Updating category ID:", editCategory.id); // 🧪 debug

      await api.put(
        `/Expenses/updateCategory/${editCategory.id}`,
        dto
      );
      alert("Category updated successfully");
    } else {
      await api.post("/Expenses/addCategory", dto);
      alert("Category added successfully");
    }

    setCategoryName("");
    setCategoryType("DAILY");
    setEditCategory(null);
    fetchCategories();

  } catch (err) {
    console.error(err);
    alert("Failed to save category");
  }
};


  const handleEdit = (cat) => {
    setEditCategory(cat);
    setCategoryName(cat.name);
    setCategoryType(cat.type);
  };

  const handleDelete = async (cat) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;
    try {
      await api.delete(`/Expenses/category/delete/${cat.id}`);
      fetchCategories();
    } catch (err) {
      console.error(err);
      alert("Failed to delete category");
    }
  };

  return (
  <div className="expense-page">
    <div className="expense-card">

      <div className="header">
        <h2>Expense Categories</h2>

        <div className="filter">
          <label>Filter</label>
          <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="DAILY">Daily</option>
            <option value="MONTHLY">Monthly</option>
          </select>
        </div>
      </div>

      {/* Add / Edit Form */}
      <div className="category-form">
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder="Category name"
        />

        <select value={categoryType} onChange={(e) => setCategoryType(e.target.value)}>
          <option value="DAILY">Daily</option>
          <option value="MONTHLY">Monthly</option>
        </select>

        <button className="primary-btn" onClick={handleAddOrUpdate}>
          {editCategory ? "Update" : "Add"}
        </button>

        {editCategory && (
          <button className="secondary-btn" onClick={() => {
            setEditCategory(null);
            setCategoryName("");
          }}>
            Cancel
          </button>
        )}
      </div>

      {/* Table */}
      {/* <div className="table-wrapper"> */}
              <div className="table-scroll-wrapper">

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {categories.length === 0 && (
              <tr>
                <td colSpan="4" className="empty">
                  No categories found
                </td>
              </tr>
            )}

            {categories.map((cat, index) => (
              <tr key={cat.id}>
                <td>{index + 1}</td>
                <td>{cat.name}</td>
                <td>
                  <span className={`badge ${cat.type.toLowerCase()}`}>
                    {cat.type}
                  </span>
                </td>
                <td>
                  <button className="edit-btn" onClick={() => handleEdit(cat)}>
                    Edit
                  </button>
                  <button className="delete-btn" onClick={() => handleDelete(cat)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
            {/* </div> */}


    </div>
  </div>
);

}

export default ExpenseCategories;
